import { render, staticRenderFns } from "./PressList.vue?vue&type=template&id=45e5df52&scoped=true"
import script from "./PressList.vue?vue&type=script&lang=js"
export * from "./PressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e5df52",
  null
  
)

export default component.exports